import { render, staticRenderFns } from "./parallaxScrolling.vue?vue&type=template&id=c863b574&scoped=true&"
import script from "./parallaxScrolling.vue?vue&type=script&lang=js&"
export * from "./parallaxScrolling.vue?vue&type=script&lang=js&"
import style0 from "./parallaxScrolling.vue?vue&type=style&index=0&id=c863b574&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c863b574",
  null
  
)

export default component.exports